import { Paper } from "@mui/material";
import { useStyles } from "./CommonStyle";

const DialogBox = (props: { childProps: any; type: number }) => {
  const classes = useStyles();
  return (
    <Paper
      sx={
        props.type === 2
          ? { minHeight: "20rem", width: "20rem" }
          : { height: "20rem", width: "20rem" }
      }
      className={
        props.type === 1
          ? classes.dialogPaper
          : props.type === 2
          ? classes.dialogProgress
          : props.type === 3
          ? classes.dialogDisconnect
          : props.type === 4
          ? classes.dialogDelete
          : props.type === 5
          ? classes.dialogDeleteProgress
          : classes.dialogSuccess
      }
    >
      {props.childProps}
    </Paper>
  );
};

export default DialogBox;
